export default __webpack_public_path__ + "static/media/bislig-rear.84592a94.png";